export default {
  install: (Vue) => {
    /** *
     * 防抖 单位时间只触发最后一次
     *  @param {?Number|300} time - 间隔时间
     *  @param {Function} fn - 执行事件
     *  @param {Boolean} stopPropagation - 是否阻止冒泡
     *  @param {?String|"click"} event - 事件类型 例："click"
     *  @param {Array} binding.value - [fn,event,time]
     *  例：<el-button v-debounce="[reset,300,`click`]">刷新</el-button>
     *  也可简写成：<el-button v-debounce="[reset]">刷新</el-button>
     */
    Vue.directive('debounce', {
      inserted (el, binding) {
        const [fn, time = 300, event = 'click', stopPropagation = true] = binding.value
        let timer
        el.addEventListener(event, (e) => {
          // eslint-disable-next-line no-unused-expressions
          timer && clearTimeout(timer)
          timer = setTimeout(() => {
            fn()
          }, time)
          if (stopPropagation) {
            e.stopPropagation()
          }
        })
      }
    })
  }
}
